import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/Inventory';

function Inventory() {
  return (
    <MainInfoTracLayout className="min-h-[100vh]">
      <Content />
    </MainInfoTracLayout>
  );
}

export default Inventory;
